import script from "./HeroBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroBlock.vue?vue&type=script&setup=true&lang=js"

import "./HeroBlock.vue?vue&type=style&index=0&id=0d9df6e3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9df6e3"]])

export default __exports__